import React,{Component} from 'react'
import { Link } from 'react-router-dom'
import{withRouter } from 'react-router-dom'

class NavItem extends Component {
    render () {

        const {location, to, children } = this.props

        let isActive = (location.pathname === to)

        return (
            <li className={isActive ? 'active' : ''}>
                <Link to={to}>{children}</Link>
            </li>
        )
    }
}

export default withRouter(NavItem)


// WEBPACK FOOTER //
// ./src/components/Shared/NavItem/index.jsx